import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FileCheck2, Printer, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { listSealedPayroll, salaryReport } from "../../api/payroll";
import { openReportWindow } from "./openSalaryReport";
import { useReportBrand } from "../reports/useReportBrand";

// الأشهر المختومة (مدفوعة ومؤكَّدة) مع بصمة التحقق وزر فتح التقرير المختوم من الأرشيف.
export const SealedMonthsCard = () => {
  const { t, i18n } = useTranslation();
  const brand = useReportBrand();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    listSealedPayroll().then(setRows).catch(() => setRows([]));
  }, []);

  const open = async (row) => {
    setBusy(row.month);
    try {
      const data = await salaryReport({
        month: row.month,
        lang: i18n.language,
        ...(row.branch_id ? { branch_id: row.branch_id } : {}),
      });
      if (!openReportWindow(data, i18n.language, { brand })) toast.error(t("salaryReport.popupBlocked"));
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy("");
    }
  };

  return (
    <NeuCard data-testid="sealed-months-card">
      <p className="label-xs flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 text-primary" /> {t("sealed.title")}
      </p>
      <p className="mt-2 text-[11px] text-muted-foreground">{t("sealed.hint")}</p>
      {rows.length ? (
        <div className="mt-4 grid gap-2">
          {rows.map((r) => (
            <div key={`${r.month}-${r.branch_id || "all"}`}
              className="flex flex-wrap items-center gap-3 rounded-2xl p-3 shadow-neu-in"
              data-testid={`sealed-row-${r.month}`}>
              <span className="font-mono text-xs font-bold" dir="ltr">{r.month}</span>
              <span className="font-mono text-[11px] text-muted-foreground" dir="ltr">
                {r.period_start} → {r.period_end} · {r.employees} · {r.total_net} {r.currency}
              </span>
              <span className="flex items-center gap-1 font-mono text-[10px] text-primary" dir="ltr"
                title={t("sealed.hashTitle")}>
                <FileCheck2 className="h-3 w-3" /> {r.hash}
              </span>
              <span className="text-[10px] text-muted-foreground" dir="ltr">
                {String(r.sealed_at || "").slice(0, 10)}
              </span>
              <NeuButton className="ms-auto flex items-center gap-1 px-3 py-1.5 text-xs"
                data-testid={`sealed-open-${r.month}`} disabled={busy === r.month} onClick={() => open(r)}>
                <Printer className="h-3.5 w-3.5" /> {t("sealed.open")}
              </NeuButton>
            </div>
          ))}
        </div>
      ) : (
        <p className="mt-3 text-xs text-muted-foreground" data-testid="sealed-empty">{t("sealed.empty")}</p>
      )}
    </NeuCard>
  );
};
